var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-legend vx-card no-shadow card-border"},[_c('h3',[_vm._v("Legend")]),_c('ul',{staticClass:"legend-list"},_vm._l((_vm.eventColors),function(color,type){return _c('li',{key:type},[_c('span',{staticClass:"legend-color",style:({ backgroundColor: color })}),_vm._v("\n      "+_vm._s(type)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }